import React from 'react'
import { BsArrowRepeat } from 'react-icons/bs';
import CopyToClip from '../../infra/CopyToClip';
import './SignUpOption.css'

export default function GuestForm({generateUsername, username}) {

  return (
    <div className='signUpForm'>
        <div className='signUpData'>
          <div style={{width: 20, cursor: 'pointer'}} onClick={generateUsername}> 
            <BsArrowRepeat/>            
          </div>
          <CopyToClip text={username} />
          <div style={{width: 200, margin:12, fontWeight:'bold'}}>{username}</div>
        </div>
    </div>);
}
